// Libraries
import { ColumnFilter, ColumnFiltersState } from '@tanstack/react-table';
// Types
import { SetColumnFilters } from '@globalTypes/index';

/**
 * Type representing the properties for the PillGroup component.
 */
export type PillGroupProps = {
  /**
   * The column filter group.
   */
  filterGroup: ColumnFilter;
  /**
   * Function for setting column filters.
   */
  setColumnFilters: SetColumnFilters<ColumnFiltersState>;
};

/**
 * Enum representing the labels for different filter groups.
 */
export enum FILTER_GROUP_LABEL {
  /**
   * Label for the "Current Rating" filter group.
   */
  CURRENT_RATING = 'Current Rating',

  /**
   * Label for the "Forecasted Rating" filter group.
   */
  FORECASTED_RATING = 'Forecasted Rating',

  /**
   * Label for the "Period CII" filter group.
   */
  PERIOD_CII = 'Period',

  /**
   * Label for the "End of Period" filter group.
   */
  END_OF_PERIOD = 'End of Period',

  /**
   * Label for the "Start of Period" filter group.
   */
  START_OF_PERIOD = 'Start of Period',
}
